<script lang="ts">
    import { onMount } from 'svelte';
    import { get } from 'svelte/store';
    import { blur } from 'svelte/transition';

    import type { ImportResponseType } from '../../shared/ColumnSelectPro/currentImport';
    import { ApiFilterBuilder } from '@automapa/svelte-automapa-template';
    import { ImportApi } from './ImportApi';
    import { api } from '../../../stores/api';
    import Spinner from '../../shared/Spinner/Spinner.svelte';
    import MessageDanger from '../../shared/Messages/MessageDanger.svelte';
    import ImportOne from './ImportOne.svelte';
    import { _ } from 'svelte-i18n';
    import type { ExportType } from '../Export/ExportType';

    let imports: ImportResponseType[] = [];
    let importFilter: ApiFilterBuilder = new ApiFilterBuilder(50).sortBy('uploaded', 'desc');
    let loading: boolean = true;
    let error: string = '';

    let downloadingInProgress: boolean = false;

    function onUpdateOne() {
        Promise.all([ImportApi.getWithQueries(get(api), {filename: 'not_null'}, importFilter)]).then(([res]) => {
            imports = res;
        });
    }

    onMount(() => {
        loading = true;
        Promise.all([ImportApi.getWithQueries(get(api), {filename: 'not_null'}, importFilter)])
            .then(([res]) => {
                imports = res;
                loading = false;
            })
            .catch(err => {
                error = $_('Error loading imports');
                loading = false;
            });
    });
</script>

{#if loading}
    <Spinner />
{:else}
    {#if error}
        <div out:blur>
            <MessageDanger header={$_(error)} />
        </div>
    {/if}
    {#each imports as _import, index (_import?.id)}
        {#if _import}
            <div out:blur>
                <ImportOne
                    showHeader={index === 0}
                    {_import}
                    bind:error
                    {onUpdateOne}
                    bind:downloadingInProgress
                />
            </div>
        {/if}
    {/each}
{/if}
